module.exports = __webpack_public_path__ + "img/code_446F6D6974697573.7a1adc32.svg";